<h2>Attori del sistema</h2>
<p>Il QRSP è elaborato e validato direttamente dal tessuto produttivo lombardo e dalle parti sociali e datoriali attraverso
i lavori della Sottocommissione QRSP della Commissione Regionale per le Politiche del Lavoro e della Formazione (CRPLF),
prevista dall'art. 8 della legge regionale n. 22 del 28 settembre 2006 "Il mercato del lavoro in Lombardia".</p>

<p>Il decreto regionale n. 6146 del 18 giugno 2009 "Adozione della procedura per l'aggiornamento del Quadro Regionale degli
Standard Professionali della Regione Lombardia" stabilisce che qualsiasi aggiornamento del QRSP venga presentato ai
componenti della Sottocommissione CRPLF cui compete "l'esame di merito sulla rispondenza del nuovo Profilo o sulle
modifiche di elementi di Profilo in rapporto alle evoluzioni del mondo del lavoro lombardo, ai fabbisogni professionali,
all'innovazione dei processi produttivi e di erogazione dei servizi".</p>

<p>Le proposte di aggiornamento del QRSP vengono valutate da un gruppo tecnico regionale che assicura la coerenza, sia a
livello di contenuto, sia a livello metodologico, con il Quadro di riferimento nazionale delle qualificazioni regionali.</p>

<p>Possono presentare proposte di aggiornamento del QRSP:</p>
<ul>
<li>I soggetti del partenariato economico sociale rappresentati nel Patto per lo Sviluppo dell'Economia, del Lavoro, della
Qualità e della coesione Sociale sottoscritto dagli Stati Generali del lavoro, dell'economia e della società lombarda in
data 19 settembre 2001;</li>

<li>Le Associazioni professionali non ordinistiche, che sono rappresentate nella Consulta regionale degli ordini, collegi e
associazioni professionali di cui alla legge regionale 14 aprile 2004 n. 7 e relativo regolamento 24 febbraio 2006 n.1;</li>

<li>I soggetti accreditati e autorizzati all'erogazione dei servizi al lavoro ai sensi della legge regionale 28 settembre
2006 n.22;</li>

<li>I soggetti accreditati e autorizzati all'erogazione dei servizi alla formazione;</li>

<li>Le Direzioni Generali di Regione Lombardia;</li>

<li>Il Comitato tecnico-scientifico di cui all'art. 4 della legge regionale 1 febbraio 2005 n.2 "Norme in materia di
discipline bionaturali".</li>
</ul>